import {Maybe} from '@coolcolduk/typescript-util';
import {BodyContainer} from '@coolcolduk/ui-mui';
import {ReactNode} from 'react';
import {User} from '@cp/model';
import NavBar from '../components/NavBar';
import LoadingPage from '../pages/other/LoadingPage';

export interface AppLayoutProps {
  user: Maybe<User> | undefined;
  children: ReactNode;
}

export default function AppLayout({user, children}: AppLayoutProps) {
  const backgroundUrl = user?.backgroundImageUrl;

  if (user === undefined) {
    return <LoadingPage />;
  }

  if (!user) {
    // Public route - no navbar
    return <BodyContainer>{children}</BodyContainer>;
  }

  // Protected route - with navbar
  return (
    <>
      <NavBar user={user} />
      <BodyContainer backgroundUrl={backgroundUrl}>{children}</BodyContainer>
    </>
  );
}
